export default {
     user:null,
     setup:null,
}